<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<!-- 조회부분 시작 -->
			<div class="sf-col sf-col-10">
				<sf-card class="p-0 h-100 card_bg">
					<pc-pcm-clam-search ref="search" :scrId="scrId"></pc-pcm-clam-search>
				</sf-card>
			</div>
			<!-- 조회부분 끝 -->

			<!-- 그리드 부분 시작 -->
			<div class="sf-col sf-col-15">
				<!--<sf-card width = "1200" height="320px">-->
				<sf-card height="320px">
					<combo-chart :height="300" ref="grpCombo" :chartData="datacollection1" :options="optionCollection1" />
				</sf-card>

				<sf-card class="p-0 border-0 bg-transparent" height="320px">
					<pc-pcm-clam-table ref="table" @Refresh="Refresh" :scrId="scrId"></pc-pcm-clam-table>
				</sf-card>
			</div>
			<!-- 그리드 부분 시작 -->
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers'; //공통
import { serviceComputed, serviceMethods } from '@mqy/clma/PcPcmClam/store/helpers';
import PcPcmClamSearch from './Search/PcPcmClamSearch.vue';
import PcPcmClamTable from './Table/PcPcmClamTable.vue';
import Chart from '@/qmsUtils/chartModule';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		datacollection1() {
			return {
				labels: this.LineChartLabel_,
				datasets: this.MixedDataSet_
			};
		},
		optionCollection1() {
			//추가
			return {
				responsive: true,
				maintainAspectRatio: false, // chart 높이 지정을 위해 필요
				plugins: {
					datalabels: {
						color: '#000', //데이터 값 표시 폰트 색상
						anchor: 'end'
					}
				},
				legend: {
					display: true,
					position: 'bottom' //범례 위치: 아래
				},
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true
							}
						}
					]
				}
			};
		}
	},
	components: { PcPcmClamSearch, PcPcmClamTable, ComboChart: Chart.ComboChart },
	methods: {
		...serviceMethods,
		Refresh() {
			this.$refs.search.searchList();
		}
	}
};
</script>

<style></style>
